export const ENV = {
  INTRANET: 'intranet',
  INNER: 'inner',
  DEVELOP: 'develop',
  TEST: 'test',
  PRE: 'pre',
  PROD: 'prod',
  LOCAL: 'local',
}

export const REQUEST_TYPE = {
  ADMIN: 'admin',
  PMS: 'pms',
  IMS: 'ims',
  WMS: 'wms',
  TWOI_WMS: 'twoiWms',
  WMS_SOCKET: 'wmsSocket',
  PLM: 'plm',
  OMS: 'oms',
  TMS: 'tms',
  LANDONG: 'landong',
  COMMON: 'common',
  CDB: 'cdb',
  COPS: 'cops',
  KOL: 'kol',
  ADS: 'ads',
  FTSP: 'ftsp',
}

const config: any = {
  [ENV.DEVELOP]: {
    [REQUEST_TYPE.ADMIN]: 'http://middlecontrol-backend-api.dev.backend',
    [REQUEST_TYPE.PMS]: 'http://pms-backend-api.dev.backend',
    [REQUEST_TYPE.IMS]: 'http://ims-backend-api.dev.backend',
    [REQUEST_TYPE.WMS]: 'http://wms-backend-api.dev.backend',
    [REQUEST_TYPE.TWOI_WMS]: 'http://wms-backend-api.dev.backend',
    [REQUEST_TYPE.PLM]: 'http://plm-backend-api.dev.backend',
    [REQUEST_TYPE.OMS]: 'http://oms-backend-api.dev.backend',
    [REQUEST_TYPE.TMS]: 'http://tms-backend-api.dev.backend',
    [REQUEST_TYPE.COMMON]: 'http://common-backend-api.dev.backend',
    [REQUEST_TYPE.LANDONG]: 'http://shenyi-middlecontrol.dev.backend',
    [REQUEST_TYPE.CDB]: 'http://cdp-backend-api.dev.backend', // TODO: 测试环境key
    [REQUEST_TYPE.COPS]: 'http://c-ops-backend-api.dev.backend',
    [REQUEST_TYPE.KOL]: 'http://kol-backend-api.dev.backend',
    [REQUEST_TYPE.ADS]: 'http://ads-backend-api.dev.backend',
    [REQUEST_TYPE.FTSP]: 'http://ftsp-backend-api.dev.backend',
  },
  [ENV.TEST]: {
    [REQUEST_TYPE.ADMIN]: 'https://middlecontrol-backend-api.test',
    [REQUEST_TYPE.PMS]: 'https://pms-backend-api.test',
    [REQUEST_TYPE.IMS]: 'https://ims-backend-api.test',
    [REQUEST_TYPE.WMS]: 'https://wms-backend-api.test',
    [REQUEST_TYPE.TWOI_WMS]: 'https://wms-backend-api.test',
    [REQUEST_TYPE.WMS_SOCKET]: 'https://wms-device-socket-api.test',
    [REQUEST_TYPE.PLM]: 'https://plm-backend-api.test',
    [REQUEST_TYPE.OMS]: 'https://oms-backend-api.test',
    [REQUEST_TYPE.TMS]: 'https://tms-backend-api.test',
    [REQUEST_TYPE.COMMON]: 'https://common-backend-api.test',
    [REQUEST_TYPE.LANDONG]: 'https://shenyi-middlecontrol.test',
    [REQUEST_TYPE.CDB]: 'https://cdp-backend-api.test', // TODO: 测试环境key
    [REQUEST_TYPE.COPS]: 'https://c-ops-backend-api.test',
    [REQUEST_TYPE.KOL]: 'https://kol-backend-api.test',
    [REQUEST_TYPE.ADS]: 'https://ads-backend-api.test',
    [REQUEST_TYPE.FTSP]: 'https://ftsp-backend-api.test',
  },
  [ENV.PRE]: {
    [REQUEST_TYPE.ADMIN]: 'https://middlecontrol-backend-api.pre-prod',
    [REQUEST_TYPE.PMS]: 'https://pms-backend-api.pre-prod',
    [REQUEST_TYPE.IMS]: 'https://ims-backend-api.pre-prod',
    [REQUEST_TYPE.WMS]: 'https://wms-backend-api.pre-prod',
    [REQUEST_TYPE.OMS]: 'https://oms-backend-api.pre-prod',
    [REQUEST_TYPE.TMS]: 'https://tms-backend-api.pre-prod',
    [REQUEST_TYPE.COMMON]: 'https://common-backend-api.pre-prod',
    [REQUEST_TYPE.LANDONG]: 'https://shenyi-middlecontrol.pre',
    [REQUEST_TYPE.CDB]: 'https://cdp-backend-api.pre-prod',
    [REQUEST_TYPE.COPS]: 'https://c-ops-backend-api.prod',
    [REQUEST_TYPE.KOL]: 'https://kol-backend-api.prod',
    [REQUEST_TYPE.ADS]: 'https://ads-backend-api.prod',
    [REQUEST_TYPE.FTSP]: 'https://ftsp-backend-api.prod',
  },
  [ENV.PROD]: {
    [REQUEST_TYPE.ADMIN]: 'https://middlecontrol-backend-api.prod',
    [REQUEST_TYPE.PMS]: 'https://pms-backend-api.prod',
    [REQUEST_TYPE.IMS]: 'https://ims-backend-api.prod',
    [REQUEST_TYPE.WMS]: 'https://wms-backend-api.prod',
    [REQUEST_TYPE.TWOI_WMS]: 'https://wms-backend-api.prod',
    [REQUEST_TYPE.PLM]: 'https://plm-backend-api.prod',
    [REQUEST_TYPE.OMS]: 'https://oms-backend-api.prod',
    [REQUEST_TYPE.TMS]: 'https://tms-backend-api.prod',
    [REQUEST_TYPE.COMMON]: 'https://common-backend-api.prod',
    [REQUEST_TYPE.LANDONG]: 'https://shenyi-middlecontrol.prod',
    [REQUEST_TYPE.CDB]: 'https://cdp-backend-api.prod',
    [REQUEST_TYPE.COPS]: 'https://c-ops-backend-api.prod',
    [REQUEST_TYPE.KOL]: 'https://kol-backend-api.prod',
    [REQUEST_TYPE.ADS]: 'https://ads-backend-api.prod',
    [REQUEST_TYPE.FTSP]: 'https://ftsp-backend-api.prod',
  },
  [ENV.LOCAL]: {
    [REQUEST_TYPE.ADMIN]: '/api',
    [REQUEST_TYPE.PMS]: '/pms',
    [REQUEST_TYPE.IMS]: '/ims',
    [REQUEST_TYPE.WMS]: '/wms',
    [REQUEST_TYPE.TWOI_WMS]: '/twoiWms',
    [REQUEST_TYPE.OMS]: '/oms',
    [REQUEST_TYPE.TMS]: '/ms',
    [REQUEST_TYPE.COMMON]: '/common',
    [REQUEST_TYPE.LANDONG]: '/landong',
    [REQUEST_TYPE.CDB]: '/cdb', // TODO: 测试环境key
    [REQUEST_TYPE.COPS]: '/cops',
    [REQUEST_TYPE.PLM]: '/plm',
    [REQUEST_TYPE.FTSP]: '/ftsp',
  },
}

export default config

export const isDev = import.meta.env.MODE === 'development'

export const getEnv = () => {
  if (isDev) {
    return ENV.TEST
  }

  const envMap = {
    develop: ENV.DEVELOP,
    test: ENV.TEST,
    pre: ENV.PRE,
    production: ENV.PROD,
  }
  const nodeEnv = import.meta.env.VITE_NODE_ENV
  if (envMap[nodeEnv]) {
    return envMap[nodeEnv]
  }

  return ENV.PROD
}
export const envConfig = (() => config[getEnv()])()
